import { render } from "./TheAboutSection.vue?vue&type=template&id=74765f52"
import script from "./TheAboutSection.vue?vue&type=script&lang=js"
export * from "./TheAboutSection.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__